<template>
  <div>
    <el-divider content-position="center">工商注册组</el-divider>
    <div>
      <el-row class="mb20" :gutter="20" style="margin: 0">
        <el-col :span="7">
          <el-card>
            <div class="charBox" ref="orderBox"></div>
            <div class="charBox" ref="orderStatusBox"></div>
          </el-card>
        </el-col>
        <el-col :span="10">
          <el-card>
            <el-row>
              <el-col :span="8">年度目标：</el-col>
              <el-col :span="8">本月目标：</el-col>
              <el-col :span="8">今日目标：</el-col>
            </el-row>
          </el-card>
        </el-col>
        <el-col :span="7">
          <el-card>ddd</el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
var echarts = require('echarts/lib/echarts')
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/toolbox')
require('echarts/lib/chart/pie')
export default {
  name: 'Business',
  data () {
    return {
      orderChart: null,
      orderStatusChart: null,
      orderData: [
        { value: 1048, name: '优开企业' },
        { value: 735, name: '本公司订单' },
        { value: 580, name: '支付宝' },
        { value: 484, name: '小程序' },
        { value: 345, name: '京东店铺' }
      ],
      orderStatusData: [
        { value: 735, name: '待沟通' },
        { value: 580, name: '沟通中' },
        { value: 484, name: '已失联' }
      ]
    }
  },
  methods: {
    initCharts () {
      this.orderChart = echarts.init(this.$refs.orderBox, 'light')
      this.setOrder()
      this.orderStatusChart = echarts.init(this.$refs.orderStatusBox, 'light')
      this.setOrderStatus()
    },
    setOrder () {
      let option = {
        title: {
          text: '订单',
          subtext: 'Fake Data',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'right'
        },
        series: [
          {
            name: '订单来源',
            type: 'pie',
            radius: '50%',
            left: 'left',
            data: this.orderData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && this.orderChart.setOption(option)
    },
    setOrderStatus () {
      let option = {
        title: {
          text: '沟通情况',
          subtext: 'Fake Data',
          left: 'left'
        },
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          left: 'right'
        },
        series: [
          {
            name: '沟通状态',
            type: 'pie',
            radius: '50%',
            left: 'left',
            data: this.orderStatusData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      option && this.orderStatusChart.setOption(option)
    }
  },
  mounted () {
    this.initCharts()
  }
}
</script>

<style lang="stylus" scoped>
.text-error {
  color: #FA5151;
}

.tr {
  text-align: right;
}

.mt10 {
  margin-top: .2rem
}

.mb20 {
  margin-bottom: .4rem
}

.charBox {
  width: 100%
  height: 6rem
}
</style>



// WEBPACK FOOTER //
// src/pages/dataization/Business.vue